import styled from "styled-components";
import { Description } from "@evergis/ui";

export const ButtonsGroupContainer = styled.div`
  padding-left: 3.5rem;
`;

export const TitleDescription = styled(Description)`
  padding: 0 0 0.5rem 3.5rem;
  margin: 0;
`;
